export const getStatus = (task, role) => {
    // console.log(task, 'statusstatusstatus');
    let endTime = new Date(task.endTime);
    let currentTime = new Date();
    let reviewTimePeriod = new Date(task.reviewTimePeriod);
    let coolDownPeriod = new Date(task.coolDownPeriod);
    let votingEndPeriod = new Date(task.votingEndPeriod);

    // console.log(currentTime > reviewTimePeriod && currentTime < coolDownPeriod, currentTime, endTime, currentTime, reviewTimePeriod, "currentTime > endTime && currentTime < reviewTimePeriod");


    if (role === 'taskDetail') {

        // Scenario 1: If end time is not passed and status is "inProgress"
        if (currentTime < endTime && task.status === "inProgress") {
            return "live";
        }
        // Scenario 2: If end time has passed and we are in the review period
        else if (currentTime > endTime && currentTime < reviewTimePeriod) {
            return "underReview";
        }
        // Scenario 3: If current time is within the cool down period
        else if (currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
            return "inDisputePeriod";
        }
        // Scenario 4: If current time is within the voting end period
        else if (currentTime > coolDownPeriod && currentTime < votingEndPeriod) {
            return "inVotingPeriod";
        }
        // Scenario 5: If all time periods have passed and isClaimed is false, and winner is selected
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.winnerSelected &&
            task.status === "ended"
        ) {
            return "winnerSelected";
        }
        // Scenario 6: If all time periods have passed and isClaimed is false, but winner is not selected refunded back to creator
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed && task.status !== "inDispute"
        ) {
            return "winnerSelected";
        }
        // Scenario 6: If all time periods have passed and isClaimed is false, but winner is not selected
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.winnerSelected &&
            task.status === "inDispute"
        ) {
            return "Winner Not Selected";
        }
        // Scenario 7: If all time periods have passed and isClaimed is true
        else if (
            currentTime > votingEndPeriod &&
            task.isClaimed
        ) {
            return "completed";
        } else {
            // Default case if no conditions are met
            return "Ended";
        }
    } else if (role === 'taskParticipated') {
        if (currentTime < endTime && task.status === "inProgress") {
            return {
                status: "live",
                tooltipColor: "#3EDD1E",
                tooltipData: " The task is active on the website and accepting participants. The due date has not yet passed.",
                classname: "greenbuttontoltip"
            };
        } else if (currentTime > endTime && currentTime < reviewTimePeriod) {
            return {
                status: "underReview",
                tooltipColor: '#4987E4',
                tooltipData: "The task creator has 24 hours to review the submissions and select a winner.",
                classname: "underReview"
            };
        } else if (currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
            return {
                status: "inDisputePeriod",
                tooltipColor: '#FF9500',
                tooltipData: "You were not selected as the winner by the task creator. You have 24 hours to open a dispute.",
                classname: "orangebuttontoltip"
            };
        } else if (currentTime > coolDownPeriod && currentTime < votingEndPeriod) {
            return {
                status: "inVotingPeriod",
                tooltipColor: '#E2C624',
                tooltipData: "The task is in the voting period. Participants are casting their votes.",
                classname: "lightbuttontoltip"
            };
        } else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.outerStatus === 'winner' &&
            task.status === "ended"
        ) {
            return {
                status: "Winner Determined",
                tooltipColor: '#FF0083',
                tooltipData: "The winner has been determined. The task outcome is final.",
                classname: "winnerSelected"
            };
        } else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.status !== "inDispute" && task.outerStatus === 'winner'
        ) {
            return {
                status: "Winner Determined",
                tooltipColor: '#FF0083',
                tooltipData: "The winner has been determined. The task outcome is final.",
                classname: "winnerSelected"
            };
        } else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.outerStatus === 'winner' &&
            task.status === "inDispute"
        ) {
            return {
                status: "Winner Not Selected",
                tooltipColor: '',
                tooltipData: "The winner has not been determined yet. The task is still being reviewed.",
                classname: "completed"
            };
        } else if (
            currentTime > votingEndPeriod &&
            task.isClaimed
        ) {
            return {
                status: "completed",
                tooltipColor: '#7B808A',
                tooltipData: "The task has been completed. No further actions are required.",
                classname: "completed"
            };
        } else {
            return {
                status: "Winner Not Determined",
                tooltipColor: '#7B808A',
                tooltipData: "The winner could not be determined. No further action available.",
                classname: "completed"
            };
        }
    } else if (role === 'taskCreated') {
        if (currentTime < endTime && task.status === "inProgress") {
            return {
                status: "live",
                tooltipColor: "#3EDD1E",
                tooltipData: " The task is active on the website and accepting participants. The due date has not yet passed.",
                classname: "greenbuttontoltip"
            };
        } else if (currentTime > endTime && currentTime < reviewTimePeriod) {
            return {
                status: "underReview",
                tooltipColor: '#4987E4',
                tooltipData: "You have 24 hours to review the submissions and select a winner.",
                classname: "underReview"
            };
        } else if (currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
            return {
                status: "inDisputePeriod",
                tooltipColor: '#FF9500',
                tooltipData: " The task is currently in dispute. The outcome is under review.",
                classname: "orangebuttontoltip"
            };
        } else if (currentTime > coolDownPeriod && currentTime < votingEndPeriod) {
            return {
                status: "inVotingPeriod",
                tooltipColor: '#E2C624',
                tooltipData: "The task is in the voting period. Participants are casting their votes.",
                classname: "lightbuttontoltip"
            };
        }  // Scenario 5: If all time periods have passed and isClaimed is false, and winner is selected
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.winnerSelected &&
            task.status === "ended"
        ) {
            return {
                status: "completed",
                tooltipColor: '#7B808A',
                tooltipData: "The task has been completed. No further actions are required.",
                classname: "completed"
            };
        }
        // Scenario 6: If all time periods have passed and isClaimed is false, but winner is not selected refunded back to creator
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed && task.status !== "inDispute"
        ) {
            return {
                status: "completed",
                tooltipColor: '#7B808A',
                tooltipData: "The task has been completed. No further actions are required.",
                classname: "completed"
            };
        }
        // Scenario 6: If all time periods have passed and isClaimed is false, but winner is not selected
        else if (
            currentTime > votingEndPeriod &&
            !task.isClaimed &&
            task.winnerSelected &&
            task.status === "inDispute"
        ) {
            return {
                status: "inDisputePeriod",
                tooltipColor: '#FF9500',
                tooltipData: "Participants who submitted their work and were not selected as the winner have 24 hours to open a dispute.",
                classname: "orangebuttontoltip"
            };
        } else {
            {
                return {
                    status: "completed",
                    tooltipColor: '#7B808A',
                    tooltipData: "The task has been completed. No further actions are required.",
                    classname: "completed"
                };
            }
        }
    }





};
